module.exports = __webpack_public_path__ + "static/media/iPhone13.dab0545c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/banner-carousel/new-banner/iPhone13.png
// module id = 1131
// module chunks = 0